import React from "react";
import { Edit, useForm } from "@refinedev/antd";
import { Form } from "antd";
import { useResource } from "@refinedev/core";
import { EditSlots } from "@evo-flywheel/ui";
import type { FieldDef } from "@evo-flywheel/contracts";
import { resourceBySlug } from "../../kit-resources";
import { FormField } from "../../fields";

export const GenericEdit: React.FC = () => {
  const { resource } = useResource();
  const meta = resourceBySlug[resource?.name ?? ""]?.meta;
  const { formProps, saveButtonProps, queryResult } = useForm();
  const record = queryResult?.data?.data as Record<string, unknown> | undefined;

  const fieldMap = new Map<string, FieldDef>(
    (meta?.fields ?? []).map((f) => [f.name, f])
  );
  const view = meta?.editView ?? [];

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <EditSlots slug={resource?.name} record={record} />
      <Form {...formProps} layout="vertical">
        {view.map((name) => {
          const field = fieldMap.get(name);
          if (!field) return null;
          return <FormField key={name} field={field} />;
        })}
      </Form>
    </Edit>
  );
};
